"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeechEffectHandler = exports.LeechEffectArgs = void 0;
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const Target_1 = require("../../Target");
const EffectType_1 = require("../EffectType");
class LeechEffectArgs {
    constructor(percent, taget = Target_1.Target.Self) {
        this.percent = percent;
        this.taget = taget;
        this.__type = EffectType_1.EffectType.Leech;
        this.__typeName = "Leech";
        this.name = "Leech";
        this.harmful = false;
    }
}
exports.LeechEffectArgs = LeechEffectArgs;
let LeechEffectHandler = class LeechEffectHandler {
    apply(sequence, container, state) {
        state.meta.eventHandlerId = container.registerEventHandlerScript(state.targetId, EventType_1.EventType.DamageDealt, Schedule_1.Schedule.Unlimited, "Effect_Leech_OnDamageDealt", {
            percent: state.args.percent,
            target: state.args.taget,
        });
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
LeechEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Leech)
], LeechEffectHandler);
exports.LeechEffectHandler = LeechEffectHandler;
